import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { EpicContainer, epicStyles } from './styles';
import { CopyToClipboard } from 'react-copy-to-clipboard';

type Props = {
    epicName: string;
}

const EpicName = ({ epicName }:Props): JSX.Element => {
    const [ copy, setCopy ] = useState(false);
    const [ show, setShow ] = useState(false);

    useEffect(() => {
        setCopy(false);
        setShow(false);
    }, [ epicName ]);

    const handleCopy = () => {
        setCopy(true);
    };

    return (
        <EpicContainer sx={{ visibility: epicName !== '' ? 'visible' : 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'end' }}>
                <div style={epicStyles} onClick={ () => setShow(!show) }>
                    <FontAwesomeIcon icon={show ? faCheckSquare : faSquare } style={{ margin: '5px 20px 0px 0px' }}/>
                    <span>EPIC Name</span>
                </div>
            </div>
            <CopyToClipboard text={epicName} onCopy={ handleCopy }>
                <span style={{ visibility: show ? 'visible' : 'hidden', cursor: 'pointer' }}>{copy ? 'Copied' : 'Click To Copy'} {epicName}</span>
            </CopyToClipboard>
        </EpicContainer>
    );
};

export default EpicName;
